import request from './request';
import TrangThaiBanModel from '../models/trang_thai_ban';

type GetAllTrangThaiBanResponse = {
  success: boolean;
  trangThaiBans?: TrangThaiBanModel[];
  data?: TrangThaiBanModel[];
  message?: string;
};

const trangThaiBanService = {
  getAllTrangThaiBan: async (): Promise<TrangThaiBanModel[]> => {
    const response = await request.get<GetAllTrangThaiBanResponse>(
      'user-sale-get-all-trang-thai-ban'
    );
    const result = response.data;

    if (!result.success) {
      throw new Error(result.message || 'Không thể tải trạng thái bàn');
    }

    return Array.isArray(result.trangThaiBans)
      ? result.trangThaiBans
      : Array.isArray(result.data)
        ? result.data
        : [];
  },
};

export default trangThaiBanService;
